import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Total from './Total';
import Label from './Label';
import Runs from './Runs';
import Tricks from './Tricks';
import Needs from './Needs';
import oget from 'oget';

export default class LeaderboardCellScores extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    onRef: PropTypes.func,
    data: PropTypes.object.isRequired,
    athlete: PropTypes.object.isRequired,
    colors: PropTypes.object.isRequired,
    scoreStyle: PropTypes.object.isRequired,
    roundConfig: PropTypes.object.isRequired,
    showJudgeScoresPopup: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    onRef() {},
  };

  render() {
    const { t, style, onRef, data, athlete, colors, trickLabel, roundConfig, scoreStyle, showJudgeScoresPopup } =
      this.props;

    const runs = oget(athlete, 'details.Runs', {});

    const tricks = oget(athlete, 'details.Tricks', {});

    const needs = oget(athlete, 'details.Needs.values[0]');

    const { showTotal, showNeeds, showRuns } = roundConfig;

    return (
      <div ref={onRef} className="cell cell-scores" style={style}>
        {showTotal && <Label>Total</Label>}

        {showTotal && (
          <Total athlete={athlete} colors={colors.scores} scoreStyle={scoreStyle}>
            {data.value}
          </Total>
        )}

        {showNeeds && <Label hide={!needs}>{t('Needs')}</Label>}

        {showNeeds && (
          <Needs t={t} hide={!needs} athlete={athlete} colors={colors.scores} scoreStyle={scoreStyle}>
            {needs}
          </Needs>
        )}

        {showRuns && <Label>{runs.label}</Label>}

        {showRuns && (
          <Runs
            athlete={athlete}
            colors={colors.scores}
            runs={runs}
            roundConfig={roundConfig}
            scoreStyle={scoreStyle}
            showJudgeScoresPopup={showJudgeScoresPopup}
          />
        )}

        <Label className="test">{trickLabel}</Label>

        <Tricks
          athlete={athlete}
          colors={colors.scores}
          values={tricks.values}
          roundConfig={roundConfig}
          scoreStyle={scoreStyle}
        />
      </div>
    );
  }
}
